const Client = require("../modules/ModHttpsClient")

module.exports = {
    roles: [],
    hasRole(roleId, user) {
        if (roleId && user) {
            let role = this.roles.find(e => e.id === roleId),
                higestRank = user.roles.reduce((a, b) => Math.max(a.rank ? a.rank : a, b.rank))

            if (role && higestRank) {
                return higestRank.rank ? (higestRank.rank >= role.rank) : (higestRank >= role.rank)
            } else {
                return false
            }
        } else {
            return false
        }
    },
    init() {
        return Client.get(null, {
            path: "/role/read/all"
        })
    }
}